const config = {
    //server: "http://localhost:5011"
    server: "https://administracionsmb.com"
}

export default config;